import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const NOTIFICATION_CENTER_STATE_MANAGER_KEY =
  'NOTIFICATION_CENTER_STATE_MANAGER_KEY';

export const useNotificationCenterOpenedStateManager = () => {
  const {cancel, isOpen, open} = useOpenedStateManager(
    NOTIFICATION_CENTER_STATE_MANAGER_KEY,
  );

  return {cancel, isOpen, open};
};
